module.exports = __webpack_public_path__ + "static/img/Testimonial.1d13865.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Testimonial.png
// module id = bGw/
// module chunks = 0